import React from 'react';
import { Container, Grid, Paper, Typography, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';
import PseudoDicomProfilesPanel from './PseudoDicomProfilesPanel';

const PseudoDicomProfilesPage = () => {
    const { isLoggedIn, user, isLoading } = useAuth();
    const { t } = useTranslation();

    const renderSkeleton = () => (
        <>
            <Sidebar user={user} />
            <Container maxWidth="xl">
                <Paper 
                    elevation={0} 
                    sx={{ 
                        p: { xs: 2, md: 4 }, 
                        mt: 4, 
                        borderRadius: 3, 
                        border: '1px solid', 
                        borderColor: 'divider', 
                        bgcolor: 'background.paper' 
                    }}
                >
                    <Skeleton variant="text" width={260} height={50} />
                    <Skeleton variant="text" width={500} height={32} sx={{ mb: 3 }} />
                    <Skeleton variant="rectangular" height={260} sx={{ borderRadius: 2 }} />
                </Paper>
            </Container>
        </>
    );

    if (!isLoggedIn || isLoading) {
        return renderSkeleton();
    }

    return (
        <>
            <Sidebar user={user} />
            <Container maxWidth="xl">
                <Paper 
                    elevation={0} 
                    sx={{ 
                        p: { xs: 2, md: 4 }, 
                        mt: 4, 
                        mb: 5,
                        borderRadius: 3, 
                        border: '1px solid', 
                        borderColor: 'divider', 
                        bgcolor: 'background.paper' 
                    }}
                >
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}>
                                {t('DicomProfilesPage.title', 'Profily DICOM Pseudonymizácie')}
                            </Typography>
                            <Typography variant="subtitle1" color="text.secondary">
                                {t(
                                    'DicomProfilesPage.subtitle',
                                    'Vytvorte si vlastné sady DICOM tagov pre rýchlu a konzistentnú pseudonymizáciu medicínskych obrazových dát.'
                                )}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <PseudoDicomProfilesPanel />
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
        </>
    );
};

export default PseudoDicomProfilesPage;